import { LDClient, LDUser } from "launchdarkly-js-client-sdk";
import { IntegrationType } from "../models";

interface IFlagFilterParams {
    tenantId: string;
    tenantRegion: string;
    integrationType?: IntegrationType;
    appId?: string;
}

export const getFeatureFlagValue = async (
    ldClient: LDClient,
    featureFlagKey: string,
    userId: string,
    parameters: IFlagFilterParams,
) => {

    if (!ldClient) {
        return false;
    }

    const currentUser = ldClient.getUser();

    const checkParametersCached = (params: IFlagFilterParams, user: LDUser): boolean => {
        return Object.keys(params).every((key) => params[key] === user.custom?.[key]);
    }

    if (
        currentUser.key === userId &&
        checkParametersCached(parameters, currentUser)
    ) {
        return ldClient.variation(featureFlagKey, false);
    }
    const newUser = { key: userId, custom: {... parameters} };

    return await ldClient.identify(newUser).then(() => ldClient.variation(featureFlagKey, false));
};
